import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20flatlay%20of%20carefully%20curated%20fashion%20essentials%20with%20sunglasses%20scarf%20wallet%20and%20small%20accessories%20on%20warm%20beige%20linen%2C%20natural%20morning%20sunlight%20from%20left%20window%2C%20editorial%20lifestyle%20photography%2C%20soft%20organic%20shadows%2C%20elevated%20minimal%20aesthetic%2C%20earthy%20sand%20and%20cream%20tones&width=1920&height=1080&seq=hero-main-v2&orientation=landscape"
          alt="ACBuy Spreadsheet Product Discovery"
          title="ACBuy Spreadsheet - Smart Product Discovery & Comparison Tool"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center pt-16">
        <div className="animate-fade-in-up">
          <p className="text-white/80 text-sm md:text-base font-medium tracking-widest uppercase mb-6">
            Product Discovery Reimagined
          </p>
        </div>

        <div className="animate-fade-in-up-delay-1">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-6">
            ACBuy Spreadsheet
          </h1>
          <p className="text-lg md:text-2xl text-white/85 font-light max-w-2xl mx-auto leading-relaxed mb-4">
            The Smartest Way to Discover &amp; Compare Products Online
          </p>
          <p className="text-sm md:text-base text-white/65 max-w-xl mx-auto leading-relaxed mb-10">
            The <strong className="text-white/90 font-semibold">acbuy spreadsheet</strong> is a data-driven product
            discovery tool designed to help users find better deals, compare prices, and track trending items in one
            centralized place. Updated daily with transparent product data.
          </p>
        </div>

        <div className="animate-fade-in-up-delay-2 flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="flex items-center gap-2 px-8 py-4 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer transition-all duration-300 bg-foreground-900 text-background-50 hover:bg-foreground-800 hover:scale-105"
          >
            Explore Categories
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <Link
            to="/acbuy-spreadsheet-guide"
            className="flex items-center gap-2 px-8 py-4 rounded-full text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-300 border-2 border-white/40 text-white hover:bg-white/15 hover:border-white/60"
          >
            Read Full Guide
            <i className="ri-book-open-line text-lg"></i>
          </Link>
        </div>

        {/* Trust Indicators */}
        <div className="animate-fade-in-up-delay-3 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { icon: 'ri-refresh-line', text: 'Updated Daily' },
            { icon: 'ri-eye-line', text: 'Transparent Data' },
            { icon: 'ri-user-smile-line', text: 'Beginner-Friendly' },
            { icon: 'ri-smartphone-line', text: 'Mobile Optimized' },
          ].map((item) => (
            <div key={item.text} className="flex items-center gap-2 text-white/75 text-sm">
              <div className="w-7 h-7 rounded-full bg-white/15 flex items-center justify-center">
                <i className={`${item.icon} text-xs`}></i>
              </div>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}